import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-voyage-professionnel',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-voyage-professionnel.component.html',
  styleUrls: ['./assurance-voyage-professionnel.component.scss']
})
export class AssuranceVoyageProfessionnelComponent {
  title = 'Assurance Voyage Professionnel';
  subtitle = '';
  heroImage = 'assets/static_pages_images/voyagepro.jpg';

  constructor(private router: Router) {}
  
  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Voyage Professionnel', link: undefined }
  ];

  prevPage = { title: 'Retraite Complémentaire Entreprise', link: '/assurance-retraite-complementaire-entreprise'
  };

  nextPage = { title: 'Mutuelle Santé Internationale', link: '/assurance-mutuelle-sante-internationale'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/logos/GENERALI.PNG' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/logos/SWISSLIFE.PNG' }
  ];

  navigateToContact(): void {
    this.router.navigate(['/'], { fragment: 'contact' });
  }
}
